import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  clientId: 'client-id',
  icon: '/assets/images/logo-small-red.svg',
  invocationType: 'STATIC_CONTENT',
  isHidden: false,
  uiHookId: () => faker.string.uuid(),
  label: 'A Fake Client',
  locationId: null,
  triggerName: 'welcome_email',
  zoneId: null,

  asEmailRegistration: trait({
    triggerName: 'registration_email',
    label: () => `Registration: ${faker.commerce.productName()}`,
  }),

  asEmailWelcome: trait({
    triggerName: 'welcome_email',
    label: () => `Welcome: ${faker.commerce.productName()}`,
  }),

  asBadgeTextField: trait({
    triggerName: 'badge_text_field',
    label: () => `Badge Text: ${faker.commerce.productName()}`,
  }),

  asBadgeQrCode: trait({
    triggerName: 'badge_qr_code',
    label: () => `QR Code: ${faker.commerce.productName()}`,
  }),

  asBadgeBarcode: trait({
    triggerName: 'badge_barcode',
    label: () => `Barcode: ${faker.commerce.productName()}`,
  }),

  asPropertyInviteCheckedIn: trait({
    triggerName: 'property_invite_checked_in',
  }),

  asPropertyInviteLog: trait({
    triggerName: 'property_invite_log_table',
    label: () => `Property Invite Log: ${faker.commerce.productName()}`,
  }),
});
